// extracted by mini-css-extract-plugin
export default {"collapseBar":"CollapseBar_collapseBar__SnJmp"};